import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { isTenantAdminUser, useAuthStore } from '@store/authStore';
import { OnboardingWizard } from '@components/Onboarding/OnboardingWizard';

export const OnboardingPage = () => {
  const navigate = useNavigate();
  const { isAuthenticated, currentUser } = useAuthStore();
  const canManageOnboarding = isTenantAdminUser(currentUser);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/auth', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  useEffect(() => {
    if (currentUser?.onboarding_complete) {
      navigate('/', { replace: true });
    }
  }, [currentUser, navigate]);

  if (!isAuthenticated || currentUser?.onboarding_complete) {
    return null;
  }

  if (!canManageOnboarding) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-surface-page px-4">
        <div className="max-w-lg rounded-xl border border-border-default bg-surface-base p-8 text-center">
          <h1 className="text-2xl font-bold text-content-primary">
            Tenant setup in progress
          </h1>
          <p className="mt-3 text-content-secondary">
            An admin for your active tenant needs to complete onboarding, including the
            QuickBooks connection, before the workspace is available.
          </p>
        </div>
      </div>
    );
  }

  return <OnboardingWizard />;
};
